import { Select, SelectOption } from "@clockwise/design-system";
import { fg_muted } from "@clockwise/design-system/tokens";
import { Room } from "@clockwise/schema";
import { MeetingRoomRounded } from "@material-ui/icons";
import { includes, map } from "lodash";
import React from "react";

const RoomIcon = () => <MeetingRoomRounded htmlColor={fg_muted} />;

export const SchemaRoomToRoomOption = (room: Room): RoomOption => ({
  label: room.name,
  value: room.id,
});

type RoomOption = {
  label: string;
  value: string;
};

type Props = {
  disabled: boolean;
  onSelect: (roomId?: string) => void; // TODO: Select needs to support select multiple for this
  options: RoomOption[];
  selected?: string;
};

export const SelectRooms = ({ disabled, onSelect, options, selected }: Props) => {
  const value = "" as const; // DEV NOTE: always keep select in "unselected" state

  const handleChange = (roomId: string) => {
    // TODO: Select needs to support select multiple for this
    if (!includes(selected, roomId)) {
      onSelect(roomId);
    }
  };

  if (!options.length) {
    return null;
  }

  return (
    <Select disabled={disabled} onChange={handleChange} size="small" value={value} variant="inline">
      <SelectOption value="">Add room</SelectOption>
      {map(options, ({ label, value }) => (
        <SelectOption
          value={value}
          key={value}
          icon={RoomIcon}
          iconProps={{ className: "cw-text-muted" }}
        >
          {label}
        </SelectOption>
      ))}
    </Select>
  );
};
